import React, {useEffect, useState} from "react";
import { useIntl } from 'react-intl';

// Components
import { Form } from 'Components';
import Pill from "Components/Pill";
import { Grid } from '@mui/material';
import TriggerLandmark from "Modules/alerts/components/wizardAlert/common/components/TriggerLandmark";


export const DriverBehavior = (props) => {

    const { value, onChange, formRef, triggers, triggersRaw } = props
    const { messages } = useIntl()
    const [showErrorTrigger, setShowErrorTrigger] = useState(false)

    useEffect(() => {
        if (value.driverBehaviorEvents == undefined)
            onChange({ ...value, driverBehaviorEvents: [] })
    }, [value])

    const pillName = {
        PotentialIncident: messages['alertsNewAlert_PotentialIncident'],
        HardStop: messages['alertsNewAlert_HardStop'],
        HardTurn: messages['alertsNewAlert_HardTurn'],
        RapidAcceleration: messages['alertsNewAlert_RapidAcceleration'],
    }

    const transformedInSelectedOptions = value.driverBehaviorEvents?.map((selectedOption) => {
        return { id: selectedOption, name: pillName[selectedOption] };
    });

    const transformedOutSelectedOptions = (options) => options.map((option) => option.id);

    const options = [
        { name: pillName['PotentialIncident'], id: 'PotentialIncident' },
        { name: pillName['HardStop'], id: 'HardStop' },
        { name: pillName['HardTurn'], id: 'HardTurn' },
        { name: pillName['RapidAcceleration'], id: 'RapidAcceleration' },
    ];

    return (
        <Form ref={formRef}
            onSubmit={() => {
                if (value.trigger) {
                    let isValid = triggersRaw?.length > 0

                    if (!isValid) {
                        setShowErrorTrigger(true)
                    } else setShowErrorTrigger(false)

                    return isValid && value.driverBehaviorEvents.length > 0
                } else {
                    return value.driverBehaviorEvents.length > 0;
                }
            }}
        >
            <Grid container justifyContent={'center'} direction={'column'} style={{ paddingTop: 10 }}>
                <Grid item >
                    <div style={{ display:'grid', paddingBottom: 10 }}>
                        <label className="input-normal-label">
                            {messages['alertsNewAlert_SelectEvents']}
                            <span className="text-danger"> *</span>
                        </label>
                        {
                            value.driverBehaviorEvents?.length == 0 &&
                            <small className="text-danger" style={{ marginTop: -5 }}>
                                {messages["alertsNewAlert_EventValidation"]}
                            </small>
                        }
                    </div>
                    <Grid container direction="row" alignItems={'center'} spacing={1} color="primary" aria-label="outlined primary button group">
                        {
                            options.map((event) => (
                                <Grid item key={event.id} sm={3}>
                                    <Pill
                                        textField={'name'}
                                        item={event}
                                        outlined={!transformedInSelectedOptions?.some((option) => option.id === event.id)}
                                        onClick={(event) => {
                                            const eventsResult = [...transformedInSelectedOptions];
                                            const checkedEvent = transformedInSelectedOptions.find((option) => option.id === event.id);
                                            if (checkedEvent) {
                                                eventsResult.splice(eventsResult.indexOf(checkedEvent), 1);
                                            } else {
                                                eventsResult.push(event);
                                            }
                                            onChange({ ...value, driverBehaviorEvents: transformedOutSelectedOptions(eventsResult) });
                                        }}
                                        style={{ border: '0', margin: '2px 0', width: '100%' }}
                                        label="pill-label-text"
                                        colorField="default"
                                    />
                                </Grid>
                            ))
                        }
                    </Grid>
                    <Grid item style={{paddingTop:25}}>
                        <TriggerLandmark config={value} triggers={triggers} triggersRaw={triggersRaw} onChange={onChange} showErrorTrigger={showErrorTrigger} />
                    </Grid>
                </Grid>
            </Grid>
        </Form>
    );
}
